<template>
  <component-wrapper class="smart-recruiters-overview-page">
    <smart-recruiters-overview
      v-if="!showCountrySelect"
      :fields="fields"
    />

    <country-selection-list-fi
      v-else
      ref="continents"
      countries-filter="job_Offer_Page"
      country-url-key="job_Offer_Page"
      :redirect-layer="showRedirectConfirmation"
    />
  </component-wrapper>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import CountrySelectionListFi from '@/components/country-selection-list-fi/CountrySelectionListFi.vue';
import SmartRecruitersOverview from '@/components/smart-recruiters/overview/SmartRecruitersOverview.vue';

interface Fields {
  showCountrySelect?: { value: boolean };
  showRedirectConfirmation?: { value: boolean };
}

const props = defineProps<{
  fields: Fields;
}>();

const showCountrySelect = computed(() => Boolean(props.fields.showCountrySelect?.value));
const showRedirectConfirmation = computed(() =>
  Boolean(props.fields.showRedirectConfirmation?.value),
);
</script>
